import React from "react"
import { graphql } from "gatsby"
import Helmet from "react-helmet"
import ArticleList from "../../components/ArticleList"
import Markdown from "../../components/Markdown"

import style from "./index.module.css";

export default ({ data }) => {
  const content = data.page
  const articles = data.articles
  return (
    <div>
      <Helmet>
        <title>{content.title}</title>
      </Helmet>
      <section className={style.content}>
        <div className={style.text}>
          {content.title &&
            <h1>{content.title}</h1>
          }
          {content.text.text &&
            <Markdown source={content.text.text} softBreak="br" className={style.richText} />
          }
        </div>
      </section>
      <section className={style.list}>
        {articles &&
          <ArticleList articles={articles} />
        }
      </section>
    </div>
  )
}

export const query = graphql`
  query {
    page: contentfulTekstpagina(contentful_id: {eq: "3Z6Z1FXYj6miam48aqCAiK"}) {
      title
      metaDescription {metaDescription}
      text {text}
    }
    articles: allContentfulNieuwsartikelUpdate(sort: {fields: [date], order: DESC}) {
      edges {
        node {
          title
          slug
          category
          date
          id
          description {
            description
          }
          imageOverview {
            fluid(maxWidth: 600) {
              sizes
              src
              srcSet
              srcWebp
              srcSetWebp
              aspectRatio
            }
          }
        }
      }
    }
  }
`